import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PurchaseService {
  PaymentLink = environment.urlglobal + '/checkout/paymentMethods/';
  countryLink = environment.urlglobal + '/country';

  constructor(
    private readonly http: HttpClient,
  ) {
  }

  public paymentMethods(token) {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.get(`${this.PaymentLink}${token}`, {headers});
  }

  public countryList() {
    return this.http.get(`${this.countryLink}`);
  }
}
